import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HiOutlineShieldCheck, HiOutlineSparkles, HiOutlineHome, HiOutlineExclamationCircle } from "react-icons/hi";
import { FaInstagram, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import ROUTES from "../../../config/routes";
import "./Footer.css";
export default function Footer() {
  useLanguage();
  const socialLinks = [{
    name: "Instagram",
    url: "https://www.instagram.com/baytbuddy.sa/",
    icon: <FaInstagram />
  }, {
    name: "X",
    url: "https://x.com/BaytBuddy_SA",
    icon: <FaXTwitter />
  }, {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61588758878447",
    icon: <FaFacebookF />
  }];
  return <footer className="bb-footer">
    <Container fluid>
      <div className="bb-footer__top-strip" />

      <Row className="g-4">
        <Col lg={4}>
          <div className="bb-footer__brand">
            <div className="bb-footer__logo">{t("BaytBuddy")}</div>
            <p className="bb-footer__text">{t("A practical room and roommate discovery platform built for shared living in Saudi Arabia.")}


            </p>

            <div className="bb-footer__mini-badge">{t("Built for safer and smarter room discovery")}

            </div>

            <div className="bb-footer__social-wrap">
              <div className="bb-footer__social-title">{t("Follow BaytBuddy")}</div>

              <div className="bb-footer__social-links">
                {socialLinks.map(item => <a key={item.name} href={item.url} className="bb-footer__social-link" target="_blank" rel="noopener noreferrer" aria-label={t(`Follow BaytBuddy on ${item.name}`)} title={t(item.name)}>

                  {t(item.icon)}
                </a>)}
              </div>
            </div>
          </div>
        </Col>

        <Col lg={4} md={6}>
          <div className="bb-footer__group">
            <div className="bb-footer__heading">{t("Why BaytBuddy")}</div>

            <div className="bb-footer__feature-list">
              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon">
                  <HiOutlineShieldCheck />
                </span>
                <span>{t("Verified-first experience")}</span>
              </div>

              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon">
                  <HiOutlineHome />
                </span>
                <span>{t("Clear and structured room details")}</span>
              </div>

              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon">
                  <HiOutlineSparkles />
                </span>
                <span>{t("Smarter room and roommate discovery")}</span>
              </div>
            </div>
          </div>
        </Col>

        <Col lg={4} md={6}>
          <div className="bb-footer__group">
            <div className="bb-footer__heading">{t("Stay Safe")}</div>

            <div className="bb-footer__feature-list">
              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon bb-footer__feature-icon--warning">
                  <HiOutlineExclamationCircle />
                </span>
                <span>{t("Visit before making any payment")}</span>
              </div>

              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon bb-footer__feature-icon--warning">
                  <HiOutlineExclamationCircle />
                </span>
                <span>{t("Verify property and lister details independently")}</span>
              </div>

              <div className="bb-footer__feature-item">
                <span className="bb-footer__feature-icon bb-footer__feature-icon--warning">
                  <HiOutlineExclamationCircle />
                </span>
                <span>{t("Be cautious while sharing personal information")}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="bb-footer__bottom">
        <div className="bb-footer__bottom-left">
          <p className="mb-0">{t("© 2026 BaytBuddy. All rights reserved.")}</p>
          <span className="bb-footer__bottom-divider">•</span>
          <span className="bb-footer__bottom-note">{t("Designed to make shared living simpler, safer, and more transparent.")}

          </span>
        </div>

        <div className="bb-footer__bottom-links">
          <Link to={ROUTES.PRIVACY_POLICY}>{t("Privacy Policy")}</Link>
          <Link to={ROUTES.TERMS_CONDITIONS}>{t("Terms & Conditions")}</Link>
        </div>
      </div>
    </Container>
  </footer>;
}
